
/**
 * 工伤类型
 */
 export const InjuryPart=[
    {
        prop:"code",
        label:"代码",
        width:"150",
        isShow:false
    },
    {
        prop:"name",
        label:"名称",
        width:"150",
        isShow:true
    },
    {
        prop:"remark",
        label:"简述",
        width:"150",
        isShow:true
    }
 ]



